import { BASE_URL } from '../constants';

import './em-product-tile-list.scss';

export default {
  bindings: {},
  transclude: true,
  templateUrl: `${BASE_URL}/em-product-tile-list/em-product-tile-list.template.html`,
};
